import NormalButton from "../../buttons/normal-button";
import AmpleHireModal from "../../modals/ample-hire-modal";

const ConfirmDeleteModal = ({
  onClickNo = () => {},
  onClickYes = () => {},
}) => {
  return (
    <AmpleHireModal modalId={"confirmDeleteModal"}>
      <h5 style={{ fontWeight: "700", fontSize: "16px", color: "var(--text-primary)", marginBottom: "16px", textAlign: "center" }}>Are you sure?</h5>
      <p style={{ fontSize: "13px", color: "var(--text-secondary)", textAlign: "center", marginBottom: "20px" }}>This action cannot be undone.</p>
      <div className="confirmDeleteModal-div-btn-layout">
        <NormalButton
          buttonTagCssClasses={"btn-clear modal-close"}
          buttonText={"Cancel"}
          onClick={onClickNo}
        />

        <NormalButton
          buttonTagCssClasses={"btn-clear btn-submit modal-close"}
          buttonText={"Delete"}
          onClick={onClickYes}
        />
      </div>
    </AmpleHireModal>
  );
};

export default ConfirmDeleteModal;
